import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import type { Coupon, CouponInput, CouponListQuery } from "@nh/shared";
import { createCoupon, listCoupons, setCouponActive, type CouponPage } from "./coupons.api";

export const couponKeys = {
  all: ["admin", "coupons"] as const,
  list: (query: CouponListQuery) => [...couponKeys.all, "list", query] as const,
};

export function useCoupons(query: CouponListQuery): UseQueryResult<CouponPage, Error> {
  return useQuery({
    queryKey: couponKeys.list(query),
    queryFn: () => listCoupons(query),
    placeholderData: (previous) => previous,
  });
}

export function useCreateCoupon(): UseMutationResult<Coupon, Error, CouponInput> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCoupon,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: couponKeys.all }),
  });
}

export function useSetCouponActive(): UseMutationResult<
  Coupon,
  Error,
  { id: string; active: boolean }
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, active }) => setCouponActive(id, active),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: couponKeys.all }),
  });
}
